module.exports = __webpack_public_path__ + "static/why-information-grows-b75c922878151365aee08cbddc36c849.jpg";